var _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47213 17.4261H3.71112C3.3326 17.4261 3.02539 17.1189 3.02539 16.7404C3.02539 16.3619 3.3326 16.0547 3.71112 16.0547H9.47213C9.85065 16.0547 10.1579 16.3619 10.1579 16.7404C10.1579 17.1189 9.85065 17.4261 9.47213 17.4261Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8032 8.56676H12.0431C11.6646 8.56676 11.3574 8.25956 11.3574 7.88104C11.3574 7.50252 11.6646 7.19531 12.0431 7.19531H17.8032C18.1818 7.19531 18.489 7.50252 18.489 7.88104C18.489 8.25956 18.1818 8.56676 17.8032 8.56676Z",
    fill: "#130F26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3630_26018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 6,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5H8.69226V10.661H3V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3630_26018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84622 6.37145C5.03341 6.37145 4.37145 7.02609 4.37145 7.83159C4.37145 8.63618 5.03341 9.2899 5.84622 9.2899C6.65995 9.2899 7.32099 8.63618 7.32099 7.83159C7.32099 7.02609 6.65995 6.37145 5.84622 6.37145ZM5.84622 10.6614C4.27728 10.6614 3 9.3923 3 7.83159C3 6.27088 4.27728 5 5.84622 5C7.41608 5 8.69244 6.27088 8.69244 7.83159C8.69244 9.3923 7.41608 10.6614 5.84622 10.6614Z",
    fill: "#130F26"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1538 15.2465C15.34 15.2465 14.6781 15.9011 14.6781 16.7057C14.6781 17.5112 15.34 18.1649 16.1538 18.1649C16.9666 18.1649 17.6276 17.5112 17.6276 16.7057C17.6276 15.9011 16.9666 15.2465 16.1538 15.2465ZM16.1538 19.5364C14.5839 19.5364 13.3066 18.2664 13.3066 16.7057C13.3066 15.145 14.5839 13.875 16.1538 13.875C17.7227 13.875 18.9991 15.145 18.9991 16.7057C18.9991 18.2664 17.7227 19.5364 16.1538 19.5364Z",
    fill: "#130F26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6fac9ed9b64431bcfa0b5f1eca229b09.svg";
export { ForwardRef as ReactComponent };